module.exports = __webpack_public_path__ + "img/logo.17be6d89.png";